<script>
import AnimationEffects from "./animation-effects";
import AnimationBaseFunctions from "./animation-base-functions";

export default {
  name: "AnimationRewardSpin",
  mixins: [AnimationEffects, AnimationBaseFunctions],
  methods: {
    animationRewardSpinDoAnimationCard: function (
      x,
      y,
      card,
      custom_class,
      parentElement,
      probabilities
    ) {
      let body = document.body;
      let element = document.createElement("gsap-reward-spin");
      element.classList.add(custom_class);

      if (parentElement) {
        parentElement.appendChild(element);
      } else {
        body.appendChild(element);
      }

      this.gsap.set(element, {
        x: x,
        y: y,
      });

      let cardObj = this.createCard(card);
      element.appendChild(cardObj.col);

      const timeline = this.gsap.timeline({ ease: "power1" });
      this.$store.commit("animations/addUnsubscribeEvents", () => {
        timeline.kill();
      });
      this.gsap.set(cardObj.front, {
        rotationY: 180,
        transformOrigin: "center bottom",
      });
      this.gsap.set(cardObj.back, {
        rotationY: 0,
        transformOrigin: "center bottom",
      });
      this.gsap.set(cardObj.icon, { scale: 0 });

      let flip_time = this.getTimeFromRarity(card.rarity, probabilities);
      let flip_degree = flip_time * 360 * 2;

      /*ANIMATION BEGINS*/
      timeline.to(
        cardObj.col,
        2,
        {
          opacity: 1,
        },
        0
      );

      timeline
        .to(cardObj.front, flip_time, { rotationY: "+=" + flip_degree + "" }, 0)
        .to(cardObj.back, flip_time, { rotationY: "+=" + flip_degree + "" }, 0)
        .to(
          cardObj.emptyOverlay,
          2,
          {
            opacity: 0,
          },
          flip_time * 0.2
        )
        .to(
          cardObj.icon,
          0.01,
          {
            onStart: () => {
              this.AnimationEffectsAnimateSmoke(165, 220, false, element);
            },
          },
          flip_time - 1.5
        )
        .fromTo(
          cardObj.icon,
          1,
          {
            scale: 0,
          },
          {
            ease: "elastic",
            transformOrigin: "center 100px",
            scale: 1,
          },
          flip_time - 0.2
        );

      return timeline;
    },

    createCard: function (card) {
      let col = document.createElement("div");
      col.classList.add("item");

      //create card front side
      let front_side = document.createElement("div");
      front_side.classList.add("cardFront");
      let img = document.createElement("img");
      img.src = require("@/assets/img/animation/full-reward-earned/cardshow-backside.png");
      front_side.appendChild(img);
      col.appendChild(front_side);

      //create card back side
      let back_side = document.createElement("div");
      back_side.classList.add("cardBack");

      //create card background
      let background = document.createElement("img");
      background.src = card.image_urls.backgrounds.collected_url;
      back_side.appendChild(background);

      //create an overlay to hide the card back
      let emptyOverlay = document.createElement("img");
      emptyOverlay.src = card.image_urls.backgrounds.empty_url;
      emptyOverlay.classList.add("empty-overlay");
      back_side.appendChild(emptyOverlay);

      //create card icon
      let icon = document.createElement("img");
      icon.src = card.image_urls.image_url;
      back_side.appendChild(icon);
      col.appendChild(back_side);

      return {
        col: col,
        front: front_side,
        back: back_side,
        icon: icon,
        emptyOverlay: emptyOverlay,
      };
    },

    getTimeFromRarity: function (rarity, probabilities) {
      rarity = rarity.toString();
      const durations = [6, 5, 5, 4, 3];
      const idx = probabilities.indexOf(rarity);
      if (idx !== -1) {
        return durations[idx];
      }
      // if doesnt match a default flip time (the lowest one)
      return durations[durations.length - 1];
    },

    getMaxCardsFromRarity: function (rarity) {
      return rarity + 1;
    },

    AnimationRewardSpinAnimate: function (
      x,
      y,
      rewardType,
      parentElement,
      card,
      probabilities
    ) {
      let custom_class = "";
      switch (rewardType.toLowerCase()) {
        case "crown":
          let crownElement = document.createElement("img");
          crownElement.src = this.$whitelabel.currencies.secondary.large;
          crownElement.classList.add("temp-crown");
          crownElement.classList.add("to-center-abs");
          if (parentElement) {
            parentElement.appendChild(crownElement);
          }
          break;

        case "card":
          custom_class = "spin-card";
          this.animationRewardSpinDoAnimationCard(
            x,
            y,
            card,
            custom_class,
            parentElement,
            probabilities
          );
          break;
        case "gold":
          let goldElement = document.createElement("img");
          goldElement.src = this.$whitelabel.currencies.primary.large;
          goldElement.classList.add("temp-gold");
          goldElement.classList.add("to-center-abs");
          if (parentElement) {
            parentElement.appendChild(goldElement);
          }
          break;
        case "loyalty":
          let element = document.createElement("img");
          element.src = this.$whitelabel.assets.features.loyalty.accent;
          element.classList.add("temp-loyalty");
          element.classList.add("to-center-abs");

          if (parentElement) {
            parentElement.appendChild(element);
          }
          break;
        case "elixir":
          let element2 = document.createElement("img");
          element2.src = this.$whitelabel.currencies.tertiary.single;
          element2.classList.add("temp-elixir");
          element2.classList.add("to-center-abs");

          if (parentElement) {
            parentElement.appendChild(element2);
          }
          break;
        case "expbooster":
          let element3 = document.createElement("img");
          element3.src = this.$whitelabel.assets.features.booster.icon;
          element3.classList.add("temp-expboost");
          element3.classList.add("to-center-abs");

          if (parentElement) {
            parentElement.appendChild(element3);
          }
          break;
        // Generic card-stack reward (used when cards are granted without a
        // specific card id, e.g. offer-chain claims). Same icon as the tile.
        case "cardpack":
          let element4 = document.createElement("img");
          element4.src =
            this.$whitelabel?.assets?.features?.cards?.icon ||
            require("@/assets/img/common/cardstack-3.png");
          element4.classList.add("temp-cardpack");
          element4.classList.add("to-center-abs");

          if (parentElement) {
            parentElement.appendChild(element4);
          }
          break;
      }
    },
  },
};
</script>

<style lang="scss">
gsap-reward-spin {
  display: block;
  position: absolute;
  background-repeat: no-repeat;
  top: 0;
  left: 0;
  pointer-events: none;

  &.spin-card {
    width: 56%;
    height: 200px;
    top: 11%;
    position: absolute;
    left: 3.5%;
    right: 0;
    margin-left: auto;
    margin-right: auto;

    .cardCont {
      float: left;
      margin-right: 10px;
      position: relative;
      cursor: pointer;
    }

    .cardFront,
    .cardBack {
      position: absolute;
      width: 100%;
      height: 100%;
      backface-visibility: hidden;
      -webkit-backface-visibility: hidden;
      -moz-backface-visibility: hidden;
      -ms-backface-visibility: hidden;

      img {
        z-index: 99;
        position: absolute;
        width: 100%;
        height: auto;
        padding: 5%;
      }
    }
  }

  .item {
    perspective: 99999px;
  }
}

.temp-loyalty {
  width: 110px;
  z-index: 9;
  top: 180px;
}
.temp-gold {
  width: 110px;
  height: 110px;
  z-index: 9;
  top: 180px;
}
.temp-crown {
  width: 110px;
  height: 110px;
  z-index: 9;
  top: 180px;
}
.temp-elixir {
  width: 170px;
  z-index: 9;
  top: 120px;
}
.temp-expboost {
  width: 110px;
  height: 83;
  z-index: 9;
  top: 180px;
}
.temp-cardpack {
  width: 110px;
  z-index: 9;
  top: 170px;
}
</style>
